import { Injectable, signal } from '@angular/core';

/**
 * Singleton state for the tenant's purchased product components.
 * Holds the flags as readonly signals; hydration is orchestrated by
 * LoadTenantComponentsUseCase (state does not fetch or depend on use cases).
 */
@Injectable({ providedIn: 'root' })
export class TenantComponentsState {
  private readonly _loaded = signal(false);
  private readonly _loadFailed = signal(false);
  private readonly _sharedServicesEnabled = signal(false);
  private readonly _employeeRelationsEnabled = signal(false);
  private readonly _employeePortalEnabled = signal(false);

  public readonly isLoaded = this._loaded.asReadonly();
  public readonly loadFailed = this._loadFailed.asReadonly();
  public readonly sharedServicesPortalEnabled = this._sharedServicesEnabled.asReadonly();
  public readonly employeeRelationsPortalEnabled = this._employeeRelationsEnabled.asReadonly();
  public readonly employeePortalEnabled = this._employeePortalEnabled.asReadonly();

  public set(sharedServices: boolean, employeeRelations: boolean, employeePortal: boolean): void {
    this._sharedServicesEnabled.set(sharedServices);
    this._employeeRelationsEnabled.set(employeeRelations);
    this._employeePortalEnabled.set(employeePortal);
    this._loaded.set(true);
  }

  public setLoadFailed(): void {
    this._loadFailed.set(true);
  }
}
